export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-6">
            关于极速影视
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            极速影视是一个专注于高清电影在线观看的综合平台，汇聚海内外最新院线大片、经典影片、热播剧集与动漫番剧。
            我们致力于为影迷打造流畅、免费、无广告干扰的极致观影体验。平台采用先进的视频加速技术，
            确保高清画质下不缓冲播放，每日同步更新热门资源，覆盖动作、科幻、悬疑、喜剧、爱情等全类型影片，
            让好电影触手可及。无论你是院线追新族还是经典重温党，极速影视都能满足你的观影需求。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-shield-check-line text-accent-600"></i>
              </div>
              <span>安全稳定</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-flashlight-line text-accent-600"></i>
              </div>
              <span>极速加载</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-movie-line text-accent-600"></i>
              </div>
              <span>海量资源</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-refresh-line text-accent-600"></i>
              </div>
              <span>每日更新</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}